import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useViewer } from '../shell';
import { checkoutIntentPath, readCheckoutIntent } from './checkout-intent';

// Sign-up and sign-in pages finish by navigating somewhere themselves (the home page after
// an email or phone check), so the resume waits until the visitor has left them.
const AUTH_PATHS = ['/login', '/register', '/verify-phone', '/verify-email', '/forgot-password', '/reset-password'];

/**
 * Takes a visitor back to the checkout they started signed out (see checkout-intent.ts) once
 * they have signed in, on the first ordinary page they reach. Only a sign-in during this
 * visit counts: someone who was already signed in when the app loaded is left where they are.
 * Mount once, inside the router.
 */
export function CheckoutIntentResumer() {
  const viewer = useViewer();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const wasSignedOut = useRef(false);
  const authLoading = viewer.authLoading ?? viewer.loading;

  useEffect(() => {
    if (authLoading) return;
    if (!viewer.isAuthenticated) {
      wasSignedOut.current = true;
      return;
    }
    if (!wasSignedOut.current || AUTH_PATHS.includes(pathname)) return;
    wasSignedOut.current = false;
    const intent = readCheckoutIntent();
    if (intent && !pathname.startsWith('/buy/')) {
      navigate(checkoutIntentPath(intent), { replace: true });
    }
  }, [authLoading, viewer.isAuthenticated, pathname, navigate]);

  return null;
}
